import I18n from 'I18n';
import isValidI18nKey from 'I18n/utils/isValidI18nKey';
export const getSectionTitle = type => {
  const key = `crmObjectBoardCard.sections.${type.toLowerCase()}.title`;
  let text = type.toLowerCase();
  if (isValidI18nKey(key)) {
    text = I18n.text(key);
  }
  return text;
};